import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { socket } from "../../../lib/socket";

export function useProjectRealtime(userId) {
  const queryClient = useQueryClient();

useEffect(() => {
  if (!userId) return;

  socket.connect();

  socket.on("connect", () => {
  });

  socket.on("projectsUpdated", () => {
    queryClient.invalidateQueries({
      queryKey: ["projects"],
      exact: false,
    });
  });

  socket.on("connect_error", (err) => {
  });

  return () => {
    socket.off("projectsUpdated");
    socket.off("connect");
  };
}, [userId]);
}